import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Fab from '@mui/material/Fab';
import Email from '@mui/icons-material/Email';
import {DialogGetSupportFab,DialogFormGetSupportFab} from '../CommonComponents/DialogBox';

import { useTranslation } from "react-i18next";

const PREFIX = 'Support';

const classes = {
  fab: `${PREFIX}-fab`,
  extendedIcon: `${PREFIX}-extendedIcon`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.fab}`]: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  },

  [`& .${classes.extendedIcon}`]: {
    marginRight: theme.spacing(1),
  }
}));

export default function FloatingSupportButton(props) {

  const {t} = useTranslation();
  const [open, setOpen] = React.useState({
    dialogSupportFab: false,
    dialogFormSupport: false
  });

  const handleClickOpen = (state) => {
    if(props.handleCloseSnackbar){
      props.handleCloseSnackbar();
    }
    setOpen({...open, [state]: true});
  };

  const handleClickClose = (state) => {
    setOpen({...open, [state]: false});
  };

  return (
    <Root className={classes.root}>
      <Fab 
        color="primary" 
        variant="extended"
        onClick={
          props.form ?
            () => handleClickOpen('dialogFormSupport') :
            () => handleClickOpen('dialogSupportFab')
        }
        className={classes.fab}
      >
        <Email className={classes.extendedIcon}/>
        {t("dialog.supportTitle")}
      </Fab>
      <DialogGetSupportFab
        toggleDialog={() => handleClickClose('dialogSupportFab')}
        open={open.dialogSupportFab}
        handleSupportSubmit={props.handleSupportSubmit}
        snackbar={props.dashboardSnackbar}
      />
      <DialogFormGetSupportFab
        toggleDialog={() => handleClickClose('dialogFormSupport')}
        open={open.dialogFormSupport}
        handleSupportSubmit={props.handleSupportSubmit}
        snackbar={props.formSnackbar}
      />
    </Root>
  );
}
FloatingSupportButton.propTypes={
  form: PropTypes.bool,
  handleSupportSubmit: PropTypes.func.isRequired,
  dashboardSnackbar: PropTypes.element,
  formSnackbar: PropTypes.element,
  handleCloseSnackbar: PropTypes.func,
}